import React from 'react';
import {IconButton} from '@mui/material';
import {Body, Icon} from '@lightricks/react-design-system';
import raiseFlashMessage from '@/utils/raiseFlashMessage';
import translate from '@/utils/translate';
import type {CampaignTrackingUrl} from '@/types/campaign';
import FlashMessage from '@/components/flash-message';
import BriefTag from './BriefTag';
import styles from './TrackingUrlItem.module.scss';

interface TrackingUrlItemProps {
  trackingUrl: CampaignTrackingUrl;
}

function TrackingUrlItem({trackingUrl}: TrackingUrlItemProps) {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(trackingUrl.url);
      raiseFlashMessage({
        status: 'success',
        mode: 'light',
        message: (
          <FlashMessage.Banner
            title={translate('URL copied to clipboard')}
            subtitle={trackingUrl.url}
          />
        ),
      });
    } catch {
      raiseFlashMessage({
        status: 'error',
        mode: 'light',
        message: (
          <FlashMessage.Banner title={translate('Failed to copy URL')} />
        ),
      });
    }
  };

  return (
    <div className={styles.container}>
      {trackingUrl.label ? <Body size="md">{trackingUrl.label}</Body> : null}
      <div className={styles.row}>
        <BriefTag label={trackingUrl.url} />
        <IconButton
          size="small"
          onClick={handleCopy}
          aria-label={translate('Copy URL')}
          className={styles.copyButton}
        >
          <Icon name="Navigation-Copy" size="small" appearance="neutral" />
        </IconButton>
      </div>
    </div>
  );
}

export default TrackingUrlItem;
